/* eslint-disable */
import HttpService from '../HttpService'

export default class FunctionService {
  constructor() {
    this._httpService = new HttpService('/sdi/function');
  }

  async FindAll() {
    return await this._httpService.get('');
  }
}